import React, { type ReactElement, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Button, Result, Spin } from 'antd';
import { get } from 'lodash';

import Impersonation from '../../../service/user/impersonation';

/** Landing of the platform admin panel's "sign in as" link: /impersonate?code=<one-time code>. */
export default function ImpersonatePage(): ReactElement {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const [error, setError] = useState<string | null>(code ? null : 'This sign-in link has no code.');

  useEffect(() => {
    if (!code) return;

    Impersonation.call(code)
      // A full load makes App pick the authorized routes; replace() keeps the spent code out of history
      .then(() => window.location.replace('/'))
      .catch((e) => setError(get(e, 'response.data.message') || e.message));
  }, [code]);

  return (
    <div className="xchange-page xchange-page--narrow">
      {error ? (
        <Result
          status="error"
          title="Could not sign in"
          subTitle={error}
          extra={
            <Button type="primary" href="/">
              Go to login page
            </Button>
          }
        />
      ) : (
        <Result icon={<Spin size="large" />} title="Signing in…" />
      )}
    </div>
  );
}
